function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Rect, G, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(Rect, {
  fill: "#002459",
  width: 61,
  height: 61,
  rx: 10
});

var _ref2 = /*#__PURE__*/React.createElement(G, {
  fill: "#002459",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Path, {
  d: "M34.602 20.028h11.439v1.759H34.602zm0 5.432h11.439v1.759H34.602zm0 5.432h11.439v1.759H34.602zm0 5.976h11.439v1.759H34.602z",
  fill: "#17bf88"
}), /*#__PURE__*/React.createElement(G, {
  stroke: "#17bf88",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement(Path, {
  d: "M26.188 24.576A4.575 4.575 0 0021.612 20a4.575 4.575 0 00-4.576 4.576 4.575 4.575 0 004.576 4.576 4.575 4.575 0 004.576-4.576z"
}), /*#__PURE__*/React.createElement(Path, {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M30.223 37.763a8.61 8.61 0 10-17.222 0"
})));

function SvgIconViewCompose(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61
  }, props), _ref, _ref2);
}

export default SvgIconViewCompose;